import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrSN: CultureInfo = {
  name: 'fr-SN',
  displayName: 'French (Senegal)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-SN',
  parent: CultureInfoFr
};
